import type { ComponentProps } from 'react';

const HealthId = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.67515 6.24532L28.4102 6.27454C29.258 6.27558 29.9427 6.96847 29.9394 7.82216L29.8731 25.1343C29.8699 25.988 29.1799 26.6792 28.3321 26.6782L4.59706 26.6489C3.74923 26.6479 3.06456 25.955 3.06783 25.1013L3.13409 7.78916C3.13736 6.93548 3.82732 6.24428 4.67515 6.24532Z"
        fill="#85CFC9"
      />
      <path
        d="M29.9272 10.7957L29.9397 7.70573C29.9411 7.32785 29.7934 6.96526 29.5291 6.69768C29.2648 6.43009 28.9055 6.2794 28.5302 6.27871L4.57122 6.25593C4.19592 6.25553 3.83543 6.40518 3.56897 6.67201C3.30252 6.93883 3.15191 7.30098 3.15025 7.67887L3.13847 10.7646L29.9272 10.7957Z"
        fill="#53A59D"
      />
      <path
        d="M14.3006 14.0048L14.2949 16.1439L7.19497 16.1436L7.20065 14.0045L14.3006 14.0048Z"
        fill="#C4E6E2"
      />
      <path
        d="M14.4125 17.5159L14.4043 19.6627L7.15501 19.6538L7.16323 17.507L14.4125 17.5159Z"
        fill="#C4E6E2"
      />
      <path
        d="M16.7032 19.3984C16.8348 20.4893 17.3043 21.5099 18.0451 22.3154C18.8944 23.2472 20.0474 23.8416 21.296 23.9913C22.5445 24.141 23.8062 23.836 24.8532 23.1315C25.9002 22.427 26.6635 21.3693 27.0052 20.1496C27.3468 18.93 27.2443 17.6286 26.7163 16.4806C26.1882 15.3326 25.2693 14.4137 24.1256 13.8898C22.9819 13.366 21.6887 13.2717 20.4797 13.624C19.2707 13.9763 18.2255 14.752 17.5329 15.8109C16.8404 16.8699 16.5461 18.1423 16.7032 19.3984Z"
        fill="#C4E6E2"
      />
      <path
        d="M21.6424 18.6659C20.6909 18.4898 20.0633 17.57 20.2407 16.6114C20.4181 15.6528 21.3333 15.0185 22.2849 15.1946C23.2364 15.3707 23.864 16.2906 23.6866 17.2491C23.5092 18.2077 22.594 18.842 21.6424 18.6659Z"
        fill="#53A59D"
      />
      <path
        d="M18.0443 22.3153C18.5343 22.8532 19.1296 23.2831 19.7929 23.5783C20.4562 23.8734 21.1732 24.0273 21.8991 24.0305C22.6249 24.0336 23.344 23.8859 24.0113 23.5965C24.6786 23.3072 25.2798 22.8824 25.7773 22.3488C25.4665 21.5767 24.9349 20.9155 24.2497 20.4489C23.5646 19.9823 22.7568 19.7313 21.9287 19.7277C21.1006 19.7241 20.2894 19.9681 19.5979 20.4288C18.9064 20.8894 18.3657 21.546 18.0443 22.3153Z"
        fill="#53A59D"
      />
      <path
        d="M14.3774 21.1838L14.3691 23.3306L7.04736 23.3216L7.05558 21.1748L14.3774 21.1838Z"
        fill="#C4E6E2"
      />
    </svg>
  );
};

export default HealthId;
